/*
Replace
nft with your resource Name :) Take care about different writings!
/!\ Nft nft Nfts nfts /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const unlockBoundariesSlice = createSlice({
  name: "unlockBoundaries",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
    updateErrorReset: (state, action) => {
      state.updating = false;
      state.updated = false;
      state.updateError = null;
    },
    listErrorReset: (state, action) => {
      state.listing = false;
      state.listed = false;
      state.listError = null;
    },
    createErrorReset: (state, action) => {
      state.creating = false;
      state.created = false;
      state.createError = null;
    },
    showErrorReset: (state, action) => {
      state.showing = false;
      state.showed = false;
      state.showError = null;
    },
  },
});

export const {
  show: showUnlockBoundary,
  update: updateUnlockBoundaries,
  list: listUnlockBoundaries,
  create: createUnlockBoundaries,
  updateErrorReset: updateUnlockBoundariesErrorReset,
  listErrorReset: listUnlockBoundariesErrorReset,
  createErrorReset: createUnlockBoundariesErrorReset,
  showErrorReset: showUnlockBoundariesErrorReset,
} = unlockBoundariesSlice.actions;
export const actions = unlockBoundariesSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const unlockBoundaries = (state) =>
  state.unlockBoundaries.idsList.map(
    (id) => state.unlockBoundaries.dictionary[id]
  );
export const unlockBoundary = (state) =>
  state.unlockBoundaries.showId &&
  state.unlockBoundaries.dictionary[state.unlockBoundaries.showId];
export const unlockBoundaryAttributes = (state) =>
  unlockBoundary(state)?.attributes;
export const unlockBoundaryRelationships = (state) =>
  unlockBoundary(state)?.relationships;
export const unlockBoundaryId = (state) => state.unlockBoundaries.showId;

export const listUnlockBoundariesForUnlockable = createSelector(
  (state) => state.unlockBoundaries.dictionary,
  (_, unlockable) => unlockable,
  (dictionary, unlockable) => {
    return Object.keys(dictionary).map((unlockBoundaryDictionaryId) => {
      return dictionary[unlockBoundaryDictionaryId]?.relationships?.unlockable
        ?.data?.id === unlockable.id &&
        dictionary[unlockBoundaryDictionaryId]?.relationships?.unlockable?.data
          ?.type === unlockable.type
        ? dictionary[unlockBoundaryDictionaryId]
        : false;
    });
  }
);

export const getUnlockBoundary = createSelector(
  (state) => state.unlockBoundaries.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getUnlockBoundaryAttributes = createSelector(
  (state) => state.unlockBoundaries.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getUnlockBoundaryRelationships = createSelector(
  (state) => state.unlockBoundaries.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getUnlockBoundaries = createSelector(
  (state) => state.unlockBoundaries.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default unlockBoundariesSlice.reducer;
